import type { ReactNode } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import Typography from '@/components/Typography';

interface AccordionSectionProps {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
}

const AccordionSection = ({ icon, title, children }: AccordionSectionProps) => {
  return (
    <Accordion
      sx={{
        backgroundColor: 'transparent',
        borderBottomWidth: 1,
        borderColor: 'rgba(248, 248, 248, 0.20)',
        borderBottomStyle: 'solid',
        width: '100%',
        p: 0
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{ p: 0, mt: 0 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Box
            sx={theme => ({
              display: 'flex',
              alignItems: 'center',
              fontSize: theme.typography.pxToRem(16)
            })}
          >
            {icon}
          </Box>
          <Typography
            component='span'
            fontWeight={700}
            size={16}
          >
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, pb: 2 }}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AccordionSection;
